import type { Control } from "react-hook-form";

import WordProcessorField from "components/word-processor-field/word-processor-field.component";

import type { TemplateSubmitData } from "./text-templates-dialog-v2.component";

interface ComposeTemplateDisplayProps {
  control: Control<TemplateSubmitData, object>;
}

export default function ComposeTemplateDisplay({
  control
}: ComposeTemplateDisplayProps) {
  return (
    <div style={{ height: "100%" }}>
      <WordProcessorField
        name="composedTemplate"
        control={control}
        placeholder="Composed Template"
        featuresGroup="light"
        allowTemplates={false}
        allowMergeTags={false}
        allowInsertMergeTagsValues={false}
        allowToolbarAutohide={false}
        autoFocus={false}
        height={630}
      />
    </div>
  );
}
